import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { SMS_RESEND_STATUSES } from '@portal/kit/pkg/services'
import { FormError, Notification } from '@portal/kit/pkg/components'

const SendSmsErrors = props =>
  <Fragment>
    {props.resendStatus === SMS_RESEND_STATUSES.SUCCESS &&
      ReactDOM.createPortal(<Notification message={props.t('account.phone_number.resend_code.success')} />, document.getElementById('notification'))
    }
    {(props.submitError || props.resendStatus === SMS_RESEND_STATUSES.ERROR) &&
      <FormError message={props.submitError || props.t('form.error')} />
    }
    {props.resendStatus === SMS_RESEND_STATUSES.LIMIT_REACHED &&
      <FormError message={props.t('account.phone_number.resend_code.limit_reached')} />
    }
  </Fragment>

SendSmsErrors.propTypes = {
  resendStatus: PropTypes.string,
  submitError: PropTypes.string,
}

export default withTranslation()(SendSmsErrors)
